import { CheckCircle2, MessageSquareReply, Pencil, Plus, Upload, XCircle } from "lucide-react";
import { fmtDateTime } from "@/components/badges";

const KINDS = {
  created: { Icon: Plus, cls: "bg-sky-100 text-sky-700" },
  edited: { Icon: Pencil, cls: "bg-slate-100 text-slate-600" },
  answered: { Icon: MessageSquareReply, cls: "bg-emerald-100 text-emerald-700" },
  fulfilled: { Icon: Upload, cls: "bg-emerald-100 text-emerald-700" },
  closed: { Icon: CheckCircle2, cls: "bg-emerald-100 text-emerald-700" },
  cancelled: { Icon: XCircle, cls: "bg-rose-100 text-rose-700" },
};

export function ActivityTimeline({ title, events, testId }) {
  if (!events?.length) return null;
  return (
    <div className="border-t border-slate-100 pt-3" data-testid={testId}>
      <div className="mb-2 font-mono text-xs uppercase tracking-wider text-slate-500">{title}</div>
      <ol className="relative ml-1.5 space-y-3 border-l border-slate-200">
        {events.map((e, i) => {
          const k = KINDS[e.kind] || KINDS.edited;
          return (
            <li key={`${e.kind}-${e.at || i}`} className="ml-4" data-testid={`${testId}-event-${e.kind}`}>
              <span className={`absolute -left-2.5 flex h-5 w-5 items-center justify-center rounded-full ring-4 ring-white ${k.cls}`}>
                <k.Icon className="h-3 w-3" />
              </span>
              <p className="text-xs font-medium text-slate-700">{e.label}</p>
              <p className="text-xs text-slate-500">
                {e.by && <span className="mr-1">{e.by} ·</span>}
                {e.at && fmtDateTime(e.at)}
              </p>
              {e.detail && <p className="mt-0.5 text-xs italic text-slate-400">{e.detail}</p>}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
